import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonPurpose } from './button-purpose';
import { ButtonType } from './button-type';
import * as i0 from "@angular/core";
const _c0 = ["mhe-button", ""];
const _c1 = ["*"];
export class MheButtonComponent {
    constructor() {
        this._checked = null;
        this.ariaExpanded = null;
        this._role = null;
        this.type = ButtonType.Button;
        this.class = '';
        this.enableLight = false;
        this.purpose = ButtonPurpose.Primary;
    }
    get btnClasses() {
        return [
            'btn',
            'ngx-shared',
            this.purpose,
            this.enableLight ? 'btn-secondary-light' : '',
            this._checked ? 'active' : '',
            this.class,
        ]
            .filter(Boolean)
            .join(' ');
    }
    set checked(value) {
        this._checked = value;
        if (typeof value === 'boolean') {
            this._role = 'switch';
        }
        else {
            this._role = null;
        }
    }
}
MheButtonComponent.ɵfac = function MheButtonComponent_Factory(t) { return new (t || MheButtonComponent)(); };
MheButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MheButtonComponent, selectors: [["button", "mhe-button", ""]], hostVars: 5, hostBindings: function MheButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("aria-checked", ctx._checked)("aria-expanded", ctx.ariaExpanded)("class", ctx.btnClasses)("role", ctx._role)("type", ctx.type);
    } }, inputs: { ariaExpanded: "ariaExpanded", type: "type", class: "class", enableLight: "enableLight", purpose: "purpose", checked: "checked" }, attrs: _c0, ngContentSelectors: _c1, decls: 1, vars: 0, template: function MheButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: ["\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MheButtonComponent, [{
        type: Component,
        args: [{ selector: 'button[mhe-button]', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: ["/*# sourceMappingURL=mheButton.css.map */\n"] }]
    }], null, { _checked: [{
            type: HostBinding,
            args: ['attr.aria-checked']
        }], ariaExpanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }, {
            type: Input
        }], btnClasses: [{
            type: HostBinding,
            args: ['attr.class']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], type: [{
            type: HostBinding,
            args: ['attr.type']
        }, {
            type: Input
        }], class: [{
            type: Input
        }], enableLight: [{
            type: Input
        }], purpose: [{
            type: Input
        }], checked: [{
            type: Input
        }] }); })();
